import { ELanguagePreference } from "../types/preference";

export interface ILanguage {
  code: ELanguagePreference;
  key: string;
}

export const languages = [
  {
    code: ELanguagePreference.EN,
    key: "english",
  },
  {
    code: ELanguagePreference.AR,
    key: "arabic",
  },
  {
    code: ELanguagePreference.RU,
    key: "russian",
  },
] as const satisfies ILanguage[];

export const defaultLanguage = ELanguagePreference.EN;
